export default "__VITE_ASSET__j1UaQPB1__ 1200w";